import { Genre } from "../../../types/cms/CmsGenreType";
import { BaseEntity } from "../baseEntity";

export class CMSGenre extends BaseEntity implements Genre {
  declare genreId: string;
  declare name: string;
  alternativeIds: string[];

  localizedName: { language: string; name: string }[];

  constructor(genre: Partial<Genre> = {}) {
    super();
    Object.assign(this, genre);
  }

  getDisplayName(): string {
    return this.name || this.genreId;
  }

  serialize() {
    return {
      genreId: this.genreId,
      alternativeIds: this.alternativeIds,
      name: this.name,
      localizedName: this.localizedName,
    };
  }
}
